import locales from "~/constants/locales";

export default function (locale: string | undefined) {
  const loc = locales.find((loc) => {
    return loc.locale === locale;
  });

  return loc?.name;
}
